import {call, put} from "redux-saga/effects";
import {getReseStoreTableData, getReseStoreTableDistinctColumnData, updateReseStoreTableData} from "../components/rese/store/ReseStoreService";
import { getReseStoreTableDataSuccess, getReseStoreTableDataError, getReseStoreTableDivisionSuccess, getReseStoreTableDivisionError,
getReseStoreTableBannerSuccess,getReseStoreTableBannerError,getReseStoreTableCitySuccess,getReseStoreTableCityError,
getReseStoreTableStateSuccess, getReseStoreTableStateError, getReseStoreTableStatusSuccess, getReseStoreTableStatusError,
updateReseStoreTableDataSuccess, updateReseStoreTableDataError,getReseStoreTableDataInit } from "../components/rese/store/redux/actions";

export function* loadReseStoreTableData ({pageNumber, pageSize, sortBy, sortDirection, filterCondition}) {
    try {
        const reseStoreData = yield call(getReseStoreTableData,pageNumber, pageSize, sortBy, sortDirection, filterCondition);
        yield put(getReseStoreTableDataSuccess(reseStoreData));
    } catch (error) {
        yield put(getReseStoreTableDataError(error.toString()));
    }
}

export function* loadReseStoreTableDivisionData ({divisionColumnPayload}) {
    try {
        const divisionData = yield call(getReseStoreTableDistinctColumnData, divisionColumnPayload);
        yield put(getReseStoreTableDivisionSuccess(divisionData));
    } catch (error) {
        yield put(getReseStoreTableDivisionError(error.toString()));
    }
}

export function* loadReseStoreTableBannerData ({bannerColumnPayload}) {
    try {
        const bannerData = yield call(getReseStoreTableDistinctColumnData, bannerColumnPayload);
        yield put(getReseStoreTableBannerSuccess(bannerData));
    } catch (error) {
        yield put(getReseStoreTableBannerError(error.toString()));
    }
}

export function* loadReseStoreTableCityData ({cityColumnPayload}) {
    try {
        const cityData = yield call(getReseStoreTableDistinctColumnData, cityColumnPayload);
        yield put(getReseStoreTableCitySuccess(cityData));
    } catch (error) {
        yield put(getReseStoreTableCityError(error.toString()));
    }
}

export function* loadReseStoreTableStateData ({stateColumnPayload}) {
    try {
        const stateData = yield call(getReseStoreTableDistinctColumnData, stateColumnPayload);
        yield put(getReseStoreTableStateSuccess(stateData));
    } catch (error) {
        yield put(getReseStoreTableStateError(error.toString()));
    }
}

export function* loadReseStoreTableStatusData ({statusColumnPayload}) {
    try {
        const statusData = yield call(getReseStoreTableDistinctColumnData, statusColumnPayload);
        yield put(getReseStoreTableStatusSuccess(statusData));
    } catch (error) {
        yield put(getReseStoreTableStatusError(error.toString()));
    }
}

export function* updateReseStoreTable ({tableData}) {
    try {
        const updatedData = yield call(updateReseStoreTableData, tableData);
        yield put(updateReseStoreTableDataSuccess(updatedData));
        yield put(getReseStoreTableDataInit(0, 10, "storeId", "ASC", ""));
    } catch (error) {
        yield put(updateReseStoreTableDataError(error.toString()));
    }
}